import { useTranslation } from "react-i18next";

//import "../../Assets/scss/components/manual-accessibility-audit-block.scss";

// component to display Scanning and Monitoring banner on dashboard
const ScanningAndMonitoringBlock = () => {

    const { t } = useTranslation();

    return (

        <div className="aioa_dashboard-manual-audit-block-inner scanning-monitoring">
            <div className="aioa_dashboard-manual-audit-block-title h5">{t('Scanning Monitoring Block Title Text')}</div>
            {/* <div className="aioa_dashboard-manual-audit-block-text">{t('Scanning Monitoring Block Description')}</div> */}
            <div className="aioa_dashboard-manual-audit-block-btn">
                <a href="https://skynetaccessibilityscan.com/trial-subscription" target="_blank" className="btn btn-primary w-100 btn-lg">{t('Scanning Monitoring Block Button Label')}</a>
            </div>
        </div>

    )
}

export default ScanningAndMonitoringBlock;